var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Badge, Grid2, IconButton, Menu, MenuItem, Stack, Tooltip, Typography, useMediaQuery, } from '@mui/material';
import { useEffect, useState } from 'react';
import { groupBy, isObject } from 'underscore';
import { colors, MuiRsTheme } from '../../styles/MuiTheme';
import SettingsIcon from '@mui/icons-material/Settings';
import { useSearchParams } from 'react-router-dom';
import { getIcon, getSprite } from '../../images/osrs/imageUtils';
import { parseModules } from '../../parsing/parse';
import { DEFAULT_FILTER_CONFIGURATION, StyleConfigSpec, } from '../../parsing/UiTypesSpec';
import { useFilterConfigStore } from '../../store/filterConfigurationStore';
import { useFilterStore } from '../../store/filterStore';
import { useSearchStore } from '../../store/search';
import { countConfigChanges } from '../../utils/configUtils';
import { searchModule, } from '../../utils/search';
import { GitHubFlavoredMarkdown } from '../GitHubFlavoredMarkdown';
import { BooleanInputComponent } from '../inputs/BooleanInputComponent';
import { DisplayConfigurationInput } from '../inputs/DisplayConfigurationInput';
import { EnumInputComponent } from '../inputs/EnumInputComponent';
import { NumberInputComponent } from '../inputs/NumberInputComponent';
import { StringListInputComponent } from '../inputs/StringListInputComponent';
import { TextInputComponent } from '../inputs/TextInputComponent';
import { ItemLabelPreview } from '../Previews';
var MAX_GROUPCOUNT_AUTOEXPAND = 3;
var InputComponent = function (_a) {
    var config = _a.config, theme = _a.theme, module = _a.module, input = _a.input, readonly = _a.readonly, persist = _a.persist;
    switch (input.type) {
        case 'number':
            var numberInput = input;
            return (_jsx(NumberInputComponent, { config: config, input: numberInput, readonly: readonly, onChange: function (value) {
                    persist(value, input.macroName);
                } }));
        case 'boolean':
            return (_jsx(BooleanInputComponent, { input: input, config: config, readonly: readonly, onChange: function (value) {
                    persist(value, input.macroName);
                } }));
        case 'enumlist':
            var enumListInput = input;
            return (_jsx(EnumInputComponent, { config: config, input: enumListInput, readonly: readonly, theme: theme, onChange: function (diff) {
                    persist(diff, input.macroName);
                } }));
        case 'stringlist':
            return (_jsx(StringListInputComponent, { config: config, input: input, readonly: readonly, theme: theme, onChange: function (diff) {
                    if (!isObject(diff)) {
                        console.error('onChange something bad happened', diff, input.macroName);
                    }
                    persist(diff, input.macroName);
                } }));
        case 'style':
            return (_jsx(DisplayConfigurationInput, { config: config, onChange: function (style) {
                    persist(style, input.macroName);
                }, readonly: readonly, module: module, input: input }));
        case 'text':
            var textInput = input;
            return (_jsx(TextInputComponent, { config: config, input: textInput, readonly: readonly, onChange: function (str) {
                    persist(str, input.macroName);
                } }));
        default:
            return (_jsxs(Typography, __assign({ variant: "h6", color: "secondary" }, { children: ["Unsupported input type:", ' ', _jsx("span", __assign({ style: { color: colors.rsOrange } }, { children: input.type }))] })));
    }
};
var InputGroup = function (_a) {
    var key = _a.key, config = _a.config, theme = _a.theme, module = _a.module, inputs = _a.inputs, readonly = _a.readonly, searchResult = _a.searchResult, onChange = _a.onChange;
    var sorted = inputs.sort(function (a, b) { return sizeOf(a) - sizeOf(b); });
    return (_jsx(Grid2, __assign({ container: true, spacing: 2 }, { children: sorted.map(function (input, index) { return (_jsx(Grid2, __assign({ sx: __assign({}, inputSearchStyle(searchResult.inputs[input.label])), size: sizeOf(input) }, { children: _jsx(InputComponent, { config: config, module: module, input: input, theme: theme, readonly: readonly, persist: function (value, macroName) {
                    var _a;
                    var _b;
                    var existing = (_b = config.inputConfigs) === null || _b === void 0 ? void 0 : _b[macroName];
                    var newConf = isObject(value)
                        ? __assign(__assign({}, (existing !== null && existing !== void 0 ? existing : {})), value) : value;
                    onChange(__assign(__assign({}, config), { inputConfigs: __assign(__assign({}, config.inputConfigs), (_a = {}, _a[macroName] = newConf, _a)) }));
                } }) }), index)); }) }), key));
};
var inputSearchStyle = function (result) {
    return result.state === 'expand'
        ? {
            border: 2,
            borderColor: colors.rsDarkYellow,
        }
        : {};
};
var sizeOf = function (input) {
    switch (input.type) {
        case 'number':
            return 4;
        case 'boolean':
            return 2;
        case 'style':
            return 16;
        default:
            return 4;
    }
};
var getPreviews = function (_a) {
    var module = _a.module;
    var styleInputs = module.inputs.filter(function (input) { return input.type === 'style'; });
    var activeFilterId = useFilterStore(function (state) {
        return Object.keys(state.filters).find(function (id) { return state.filters[id].active; });
    });
    var configForModule = useFilterConfigStore(function (state) { var _a, _b; return (_b = (_a = state.filterConfigurations) === null || _a === void 0 ? void 0 : _a[activeFilterId]) === null || _b === void 0 ? void 0 : _b.inputConfigs; });
    var visibleStyleInputs = styleInputs.filter(function (input) {
        var _a, _b;
        var config = StyleConfigSpec.optional()
            .default({})
            .parse(configForModule === null || configForModule === void 0 ? void 0 : configForModule[input.macroName]);
        return !((_a = config === null || config === void 0 ? void 0 : config.hidden) !== null && _a !== void 0 ? _a : (_b = input.default) === null || _b === void 0 ? void 0 : _b.hidden);
    });
    return visibleStyleInputs.slice(0, 4).map(function (input) {
        var macroName = input.macroName;
        return (_jsx(ItemLabelPreview, { itemName: input.label, input: input }, macroName));
    });
};
var getPreviewsForGroup = function (_a) {
    var module = _a.module, groupName = _a.groupName;
    var styleInputs = module.inputs.filter(function (input) { return input.type === 'style' && input.group === groupName; });
    var activeFilterId = useFilterStore(function (state) {
        return Object.keys(state.filters).find(function (id) { return state.filters[id].active; });
    });
    var configForModule = useFilterConfigStore(function (state) { var _a, _b; return (_b = (_a = state.filterConfigurations) === null || _a === void 0 ? void 0 : _a[activeFilterId]) === null || _b === void 0 ? void 0 : _b.inputConfigs; });
    var visibleStyleInputs = styleInputs.filter(function (input) {
        var _a, _b, _c;
        var config = StyleConfigSpec.optional()
            .default({})
            .parse(configForModule === null || configForModule === void 0 ? void 0 : configForModule[input.macroName]);
        return !((_c = (_a = config === null || config === void 0 ? void 0 : config.hideOverlay) !== null && _a !== void 0 ? _a : (_b = input.default) === null || _b === void 0 ? void 0 : _b.hideOverlay) !== null && _c !== void 0 ? _c : false);
    });
    return visibleStyleInputs.slice(0, 4).map(function (input) {
        var macroName = input.macroName;
        return (_jsx(ItemLabelPreview, { itemName: input.label, input: input }, macroName));
    });
};
var ModuleGroup = function (_a) {
    var module = _a.module, group = _a.group, readonly = _a.readonly, groupCount = _a.groupCount, inputs = _a.inputs, index = _a.index, config = _a.config, theme = _a.theme, searchResult = _a.searchResult, onChange = _a.onChange;
    var groupName = group || 'Default Group';
    var groupConfig = module.groups.find(function (g) { return g.name === groupName; });
    var groupDescription = groupConfig === null || groupConfig === void 0 ? void 0 : groupConfig.description;
    var groupExpanded = groupConfig === null || groupConfig === void 0 ? void 0 : groupConfig.expanded;
    var groupIconConfig = groupConfig === null || groupConfig === void 0 ? void 0 : groupConfig.icon;
    var _b = useState(undefined), groupIcon = _b[0], setGroupIcon = _b[1];
    useEffect(function () {
        var _a, _b;
        switch (groupIconConfig === null || groupIconConfig === void 0 ? void 0 : groupIconConfig.type) {
            case 'itemId':
                getIcon(groupIconConfig.itemId, setGroupIcon);
                break;
            case 'sprite':
                getSprite((_a = groupIconConfig.spriteId) !== null && _a !== void 0 ? _a : 0, (_b = groupIconConfig.spriteIndex) !== null && _b !== void 0 ? _b : 0, setGroupIcon);
                break;
            default:
                break;
        }
    }, [setGroupIcon, groupIconConfig]);
    var groupPreviews = getPreviewsForGroup({
        module: module,
        groupName: groupName,
    });
    return (_jsxs(Accordion, __assign({ disableGutters: true, defaultExpanded: groupExpanded !== null && groupExpanded !== void 0 ? groupExpanded : groupCount <= MAX_GROUPCOUNT_AUTOEXPAND, expanded: searchResult.state === 'expand' ? true : undefined, sx: {
            '::before': { display: 'none' },
            display: searchResult.state === 'hide' ? 'none' : undefined,
        }, slotProps: { transition: { unmountOnExit: true } } }, { children: [_jsxs(AccordionSummary, __assign({ component: "div", expandIcon: _jsx(ExpandMore, {}), sx: {
                    flexDirection: 'row-reverse',
                    backgroundColor: colors.rsLighterBrown,
                } }, { children: [_jsxs("div", __assign({ style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                        } }, { children: [groupIcon && (_jsx("img", { style: {
                                    verticalAlign: 'middle',
                                    width: '36px',
                                    height: '36px',
                                    objectFit: 'contain',
                                }, src: groupIcon.src, alt: groupIcon.name })), _jsx(Typography, __assign({ sx: { alignSelf: 'center' } }, { children: group }))] })), _jsx(Stack, __assign({ direction: "row", sx: {
                            flex: '1',
                            flexWrap: 'wrap',
                            justifyContent: 'flex-end',
                            gap: '8px',
                            alignItems: 'center',
                        } }, { children: groupPreviews }))] })), _jsxs(AccordionDetails, __assign({ sx: {
                    border: 2,
                    borderColor: colors.rsLighterBrown,
                } }, { children: [_jsx(GitHubFlavoredMarkdown, { gfmd: groupDescription !== null && groupDescription !== void 0 ? groupDescription : '' }), _jsx(InputGroup, { config: config, module: module, inputs: inputs, readonly: readonly, searchResult: searchResult, onChange: onChange, theme: theme }, index)] }))] })));
};
var ModuleSection = function (_a) {
    var _b, _c;
    var activeFilterId = _a.activeFilterId, expanded = _a.expanded, setExpanded = _a.setExpanded, module = _a.module, readonly = _a.readonly, config = _a.config, theme = _a.theme, onChange = _a.onChange, clearConfiguration = _a.clearConfiguration, setEnabledModule = _a.setEnabledModule, showSettings = _a.showSettings;
    var groupedInputs = groupBy(module.inputs.map(function (input) {
        var _a;
        return (__assign(__assign({}, input), { group: (_a = input.group) !== null && _a !== void 0 ? _a : '' }));
    }), 'group');
    var defaultGroup = groupedInputs[''] || [];
    delete groupedInputs[''];
    var groupCount = Object.keys(groupedInputs).length;
    var moduleEnabledDefaultValue = module.enabled;
    var configuredEnableValue = (_b = config.enabledModules) === null || _b === void 0 ? void 0 : _b[module.id];
    var enabled = configuredEnableValue !== null && configuredEnableValue !== void 0 ? configuredEnableValue : moduleEnabledDefaultValue;
    var showPreviews = useMediaQuery(MuiRsTheme.breakpoints.up('sm'));
    var previews = getPreviews({ module: module });
    var moduleMacronames = module.inputs.map(function (input) { return input.macroName; });
    var configCount = countConfigChanges(config, moduleMacronames);
    var _d = useState(null), menuAnchor = _d[0], setMenuAnchor = _d[1];
    var search = useSearchStore().search;
    var searchResult = searchModule(module, search);
    return (_jsxs(_Fragment, { children: [_jsxs(Menu, __assign({ anchorEl: menuAnchor, open: !!menuAnchor, onClose: function () { return setMenuAnchor(null); } }, { children: [_jsx(MenuItem, __assign({ onClick: function () {
                            clearConfiguration(activeFilterId, module.inputs
                                .map(function (input) {
                                return input.macroName;
                            })
                                .reduce(function (acc, macroName) {
                                if (typeof macroName === 'string') {
                                    return __spreadArray(__spreadArray([], acc, true), [macroName], false);
                                }
                                else {
                                    return __spreadArray(__spreadArray([], acc, true), [
                                        macroName.includes,
                                        macroName.excludes,
                                    ], false);
                                }
                            }, []));
                        } }, { children: "Reset Module" })), _jsx(MenuItem, __assign({ onClick: function () {
                            setEnabledModule(activeFilterId, module.id, !enabled);
                        } }, { children: enabled ? 'Disable Module' : 'Enable' }))] })), _jsxs(Accordion, __assign({ slotProps: { transition: { unmountOnExit: true } }, expanded: (expanded || searchResult.state === 'expand') && enabled, onChange: function () {
                    if (searchResult.state !== 'expand') {
                        setExpanded(!expanded);
                    }
                }, sx: {
                    '&::before': {
                        backgroundColor: colors.rsDarkBrown,
                    },
                    filter: !enabled ? 'grayscale(0.75)' : 'none',
                    display: searchResult.state === 'hide' ? 'none' : undefined,
                } }, { children: [_jsxs(AccordionSummary, __assign({ component: "div", expandIcon: _jsx(ExpandMore, {}), sx: {
                            '& .MuiAccordionSummary-content': {
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: '16px',
                            },
                            flexDirection: 'row-reverse',
                            gap: '16px',
                        } }, { children: [_jsxs(Stack, { children: [_jsx(Typography, __assign({ variant: "h4", color: "primary" }, { children: module.name })), (module === null || module === void 0 ? void 0 : module.subtitle) && (_jsx(Typography, __assign({ variant: "h6", component: "span", color: "secondary" }, { children: module === null || module === void 0 ? void 0 : module.subtitle })))] }), showPreviews && (_jsx(Stack, __assign({ direction: "row", sx: {
                                    flex: '1',
                                    flexWrap: 'wrap',
                                    justifyContent: 'flex-end',
                                    gap: '8px',
                                    alignItems: 'center',
                                } }, { children: previews }))), showSettings ? (_jsx(Tooltip, __assign({ title: configCount
                                    ? "".concat(configCount, " settings changed")
                                    : '' }, { children: _jsx(IconButton, __assign({ onClick: function (e) {
                                        e.stopPropagation();
                                        setMenuAnchor(e.currentTarget);
                                    } }, { children: _jsx(Badge, __assign({ badgeContent: configCount, color: "secondary" }, { children: _jsx(SettingsIcon, {}) })) })) }))) : null] })), _jsx(AccordionDetails, { children: _jsxs(Stack, __assign({ spacing: 2, direction: "column" }, { children: [_jsx(Stack, __assign({ sx: { display: 'block' }, direction: "row", justifyContent: "flex-end" }, { children: _jsx(GitHubFlavoredMarkdown, { gfmd: (_c = module.description) !== null && _c !== void 0 ? _c : '' }) })), _jsx(InputGroup, { config: config, module: module, inputs: defaultGroup, readonly: readonly, searchResult: searchResult.groups['_'], onChange: onChange, theme: theme }, -1), Object.entries(groupedInputs).map(function (_a, index) {
                                    var group = _a[0], inputs = _a[1];
                                    return (_jsx(ModuleGroup, { index: index, config: config, theme: theme, module: module, group: group, groupCount: groupCount, inputs: inputs, readonly: readonly, searchResult: searchResult.groups[group], onChange: onChange }, index));
                                })] })) })] }))] }));
};
export var CustomizeTab = function (_a) {
    var _b, _c, _d;
    var filter = _a.filter, config = _a.config, onChange = _a.onChange, clearConfiguration = _a.clearConfiguration, setEnabledModule = _a.setEnabledModule, extraComponent = _a.extraComponent, readonly = _a.readonly, sx = _a.sx, _e = _a.showSettings, showSettings = _e === void 0 ? true : _e;
    var searchParams = useSearchParams()[0];
    var expandByDefault = searchParams.get('expanded') === 'true';
    var _f = useState(expandByDefault
        ? Object.fromEntries((_b = filter === null || filter === void 0 ? void 0 : filter.modules.map(function (module) { return [module.name, true]; })) !== null && _b !== void 0 ? _b : [])
        : {}), expandedModules = _f[0], setExpandedModules = _f[1];
    var setAllExpanded = function (expanded) {
        var newExpandedModules = {};
        filter === null || filter === void 0 ? void 0 : filter.modules.forEach(function (module) {
            newExpandedModules[module.name] = expanded;
        });
        setExpandedModules(newExpandedModules);
    };
    useEffect(function () {
        var handleExpandAll = function (event) {
            setAllExpanded(event.detail);
        };
        window.addEventListener('expandAll', handleExpandAll);
        return function () {
            window.removeEventListener('expandAll', handleExpandAll);
        };
    }, [filter]);
    if (!filter) {
        return (_jsx(Typography, __assign({ variant: "h4", color: "primary" }, { children: "No filter selected" })));
    }
    var modules = __spreadArray(__spreadArray(__spreadArray([], (((_c = parseModules((config === null || config === void 0 ? void 0 : config.prefixRs2f) || '')) === null || _c === void 0 ? void 0 : _c.modules) || []), true), filter.modules, true), (((_d = parseModules((config === null || config === void 0 ? void 0 : config.suffixRs2f) || '')) === null || _d === void 0 ? void 0 : _d.modules) || []), true);
    return (_jsx("div", __assign({ style: __assign({}, sx) }, { children: _jsx(Stack, { children: modules
                .filter(function (m) { return !m.hidden; })
                .map(function (module, index) {
                var _a, _b;
                return (_jsx(ModuleSection, { readonly: readonly, activeFilterId: filter.id, module: module, showSettings: showSettings, config: config !== null && config !== void 0 ? config : DEFAULT_FILTER_CONFIGURATION, theme: (_a = filter.themes) === null || _a === void 0 ? void 0 : _a.find(function (t) { return t.id === (config === null || config === void 0 ? void 0 : config.selectedThemeId); }), onChange: onChange, clearConfiguration: clearConfiguration, setEnabledModule: setEnabledModule, expanded: (_b = expandedModules[module.name]) !== null && _b !== void 0 ? _b : false, setExpanded: function (expanded) {
                        return setExpandedModules(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[module.name] = expanded, _a)));
                        });
                    } }, index));
            }) }) })));
};
